// Signing-record helpers (pure — no React, no Supabase) shared by the packet
// renderer and the sample data. Builds the per-party audit summary printed on
// the Electronic Signature Certificate: who signed, how the link reached them,
// when it was opened, when they signed and from which address — the same facts
// SignWell prints on its signing certificate.

// slotsMeta: [{ party_role, signer_label, signed_name, signed_at, signed_by, signed_ip, signed_user_agent }]
// tokens:    [{ party_role, sent_to_email, created_at, accessed_at, access_count }] (external links)
export function buildParties(slotsMeta = [], tokens = []) {
  const order = [];
  const byRole = {};
  slotsMeta.forEach((s) => {
    if (!byRole[s.party_role]) { byRole[s.party_role] = { role: s.party_role, slots: [] }; order.push(s.party_role); }
    byRole[s.party_role].slots.push(s);
  });
  return order.map((role) => {
    const p = byRole[role];
    const signed = p.slots.filter((s) => s.signed_at);
    const toks = tokens.filter((t) => t.party_role === role);
    const latest = (arr, k) => arr.map((x) => x[k]).filter(Boolean).sort().slice(-1)[0] || null;
    const earliest = (arr, k) => arr.map((x) => x[k]).filter(Boolean).sort()[0] || null;
    const staff = signed.some((s) => s.signed_by);
    return {
      role,
      name: signed[0]?.signed_name || '',
      label: p.slots[0]?.signer_label || role,
      sections: p.slots.length,
      signedSections: signed.length,
      email: toks.map((t) => t.sent_to_email).filter(Boolean).slice(-1)[0] || null,
      sentAt: earliest(toks, 'created_at'),
      viewedAt: latest(toks, 'accessed_at'),
      signedAt: latest(signed, 'signed_at'),
      ip: signed.map((s) => s.signed_ip).filter(Boolean)[0] || null,
      userAgent: signed.map((s) => s.signed_user_agent).filter(Boolean)[0] || null,
      method: signed.length === 0 ? 'pending' : (staff ? 'caera' : 'link'),
    };
  });
}
